import { useEffect, useRef, useState } from "react";

import { useAppContext } from "../../context/appContext";
import { PieceResponseDTO } from "../../openapi-generated-client";
import ComposerPieceInfoGroup from "./info-group/composerPieceInfoGroup";
import DescriptionPieceInfoGroup from "./info-group/descriptionPieceInfoGroup";
import DownloadsPieceInfoGroup from "./info-group/downloadsPieceInfoGroup";
import KeywordsPieceInfoGroup from "./info-group/keywordsPieceInfoGroup";
import PerformancesPieceInfoGroup from "./info-group/performancesPieceInfoGroup";
import PieceInfoGroup from "./info-group/pieceInfoGroup";
import StatsPieceInfoGroup from "./info-group/statsPieceInfoGroup";
import "./mobilePieceInfoGroups.css";
import MobilePieceInfoGroupsInner from "./mobilePieceInfoGroupsInner";
import MobileSinglePieceNavigation from "./mobileSinglePieceNavigation";
import MovementsPieceInfoGroup from "./info-group/movementsPieceInfoGroup";

interface MobilePieceInfoGroupProps {
    piece: PieceResponseDTO;
    canDownload: boolean;
    active: number;
    setActive: (active: number) => void;
    id: string;
}

export default function MobilePieceInfoGroups(props: MobilePieceInfoGroupProps) {

    const {pieceController, sessionId} = useAppContext();

    const swipeBreakpoint = 50;

    const [swipeOffset, setSwipeOffset] = useState(0);
    const easingOutSwipeOffset = useRef(false);

    const [minHeight, setMinHeight] = useState(0);

    function updateMinHeight(newHeight: number) {
        if(newHeight > minHeight) {
            setMinHeight(newHeight);
        }
    }

    function stopSwipe() {
        document.onmouseup = null;
        document.onmousemove = null;
        setTimeout(() => {
            easeOutSwipeOffset();
        }, 200);
    }

    function easeOutSwipeOffset() {
        if(swipeOffset == 0) {
            easingOutSwipeOffset.current = false;
            return;   
        }
        easingOutSwipeOffset.current = true;
        setSwipeOffset(swipeOffset > 0 ? swipeOffset - 1 : swipeOffset + 1);
    }

    useEffect(() => {
        if(easingOutSwipeOffset.current) {
            easeOutSwipeOffset();
            return;
        }
        if(swipeOffset > swipeBreakpoint) {
            if(props.active > 0) {
                props.setActive(props.active - 1);
            }
            stopSwipe();
        }else if(swipeOffset < -swipeBreakpoint) {
            if(props.active < 3) {
                props.setActive(props.active + 1);
            }
            stopSwipe();
            
        }

    }, [swipeOffset]);

    return <>
    <MobileSinglePieceNavigation swipeOffset={swipeOffset} active={props.active} setActive={props.setActive}/>
    <div className="mobile-piece-info-groups" id={props.id} style={{
        minHeight: minHeight + "px"
    }}>
        <MobilePieceInfoGroupsInner minHeight={minHeight} easeOutSwipe={easeOutSwipeOffset} swipeOffset={swipeOffset} setSwipeOffset={setSwipeOffset} updateHeight={updateMinHeight} id={0} active={props.active}>
            <PieceInfoGroup><StatsPieceInfoGroup piece={props.piece}/></PieceInfoGroup>
            <PieceInfoGroup><KeywordsPieceInfoGroup piece={props.piece}/></PieceInfoGroup>
            <PieceInfoGroup><DescriptionPieceInfoGroup piece={props.piece}/></PieceInfoGroup>
            <PieceInfoGroup><MovementsPieceInfoGroup piece={props.piece}/></PieceInfoGroup>
        </MobilePieceInfoGroupsInner>
        <MobilePieceInfoGroupsInner minHeight={minHeight} easeOutSwipe={easeOutSwipeOffset} swipeOffset={swipeOffset} setSwipeOffset={setSwipeOffset} updateHeight={updateMinHeight} id={1} active={props.active}>
            <PieceInfoGroup><ComposerPieceInfoGroup piece={props.piece}/></PieceInfoGroup>
        </MobilePieceInfoGroupsInner>
        <MobilePieceInfoGroupsInner empty={props.piece.performances.length === 0} minHeight={minHeight} easeOutSwipe={easeOutSwipeOffset} swipeOffset={swipeOffset} setSwipeOffset={setSwipeOffset} updateHeight={updateMinHeight} id={2} active={props.active}>
            <PieceInfoGroup><PerformancesPieceInfoGroup piece={props.piece}/></PieceInfoGroup>
        </MobilePieceInfoGroupsInner>
        <MobilePieceInfoGroupsInner minHeight={minHeight} easeOutSwipe={easeOutSwipeOffset} swipeOffset={swipeOffset} setSwipeOffset={setSwipeOffset} updateHeight={updateMinHeight} id={3} active={props.active}>
            <PieceInfoGroup fullWidth><DownloadsPieceInfoGroup sessionId={sessionId} canDownload={props.canDownload} piece={props.piece}/></PieceInfoGroup>
        </MobilePieceInfoGroupsInner>
    </div>
    </>;
}